import router from '../router'
import store from '../store'
import {
  utils
} from '@/utils/utils'
// import {
//   bamApi
// } from "@control/services";
import { mainApi } from '@main/services';
// // 是否是子账号
// let isMainLogin = utils.getCookie('_need_main_username_')
// let isLoginProtect = localStorage.getItem("isLoginProtect");
// // 子账号
// if (isMainLogin == 'true' && (!isLoginProtect || isLoginProtect === 'false')) { //开启手机或邮箱
//   isOpenChildAccountProtect()
// }

// function isOpenChildAccountProtect() {
//   bamApi.bamCustomerSecurityLogin().then(function (res) {
//     let result = res.result;
//     let obj = res.obj;
//     if (result) {
//       // loginProtect 0 关闭  1 手机  2 邮箱
//       if (obj.loginProtect && obj.loginProtect !== 0) {
//         localStorage.setItem("loginProtect", obj.loginProtect)
//         localStorage.setItem("loginProtectV", obj.loginProtect == 1 ? obj.telephone : obj.email)
//         router.push({
//           path: "/account/loginVerify"
//         });
//       }
//     }
//   })
// }


router.onReady(() => {
  console.log('enter onReady')
})

// const visitorMenuPath=['user-center/account','user-center/account/base-info','user-center/account/certification','user-center/account/address','plan','plan/channelPlan','plan/channelPlanApply','plan/protocol/index','plan/policy/index','auth','auth/index','auth/roleList','auth/personnel'] //固定的账号中心、基本信息、实名认证、渠道计划、渠道计划（子菜单）、已申请渠道计划、已签署协议, 伙伴政策， 组织权限
const filterVisitorMenu = (array,parentPath='') => {
  if (array instanceof Array) {
    return array.filter(item => {
      const path = parentPath?parentPath + '/'+item.path:item.path;
      // if (visitorMenuPath.includes(path)) {
        // if (item.children && item.children.length) {
        //   item.children=filterVisitorMenu(item.children,path)
        // }
        // （分销中心账号中心只保留多云绑定）没有配置多云绑定子菜单则不展示父级菜单账号中心
        if(path === 'user-center/account'){
          let flag = false;
          if(item.children instanceof Array){
            item.children.forEach(item2=>{
              if(item2.path === "base-info" || item2.path === "certification" || item2.path === "address"){
                flag = true;
              }
            })
          }
          return flag;
        }
        return true
      // }
    });
    }
}

let flag;
let getMenuList = async ()=>{
  let localMenu = [];
  await mainApi.getLeftMenuData({}).then(response => {
    const { obj } = response;
    if (!obj || !obj[0] || !obj[0].children) {
      console.log("菜单数据返回空");
      return;
    }
    let menuData = [...obj[0].children];
    //过滤访客菜单，SE制定由前端写死，若后端菜单code变化则会出现问题
    menuData = filterVisitorMenu(menuData)
    menuData = utils.mapMenuData(menuData);
    utils.mapMenuChildren(menuData);
    if(menuData && Array.isArray(menuData)){
      menuData.forEach(item1=>{
        if(item1.children){
          item1.children.forEach(item2=>{
            localMenu.push({
              code:item2.code,
              path:`/${item1.path}/${item2.path}`
            });
          })
        }else{
          localMenu.push({
            code:item1.code,
            path:`/${item1.path}`
          });
        }
        flag = true;
      })
    }
    /**
     * 这里要对新的菜单做一次处理
     */
    store.$menuDataChanged(menuData)
    store.commit("setleftMenuData", menuData);
    // localStorage.setItem("leftMenuData", JSON.stringify(menuData));
    // store.commit("setMenuTitle", "伙伴控制台");
    store.commit("setMenuTitle", obj[0].name);
    // localStorage.setItem("leftMenuTitle", obj[0].name);
    // localStorage.setItem("leftMenuTitle", "伙伴控制台");
    }).catch(e => {
      console.log(e);
    });
    localStorage.setItem("localMenu",JSON.stringify(localMenu));
    return localMenu;
}
let getCurrentMenuCode = async to => {
  let menuList = localStorage.getItem("localMenu");
  if (!menuList || !flag) {
    menuList = await getMenuList();
    menuList = menuList?menuList:[];
  }else{
    try{
      menuList = JSON.parse(menuList);
    }catch(e){
      menuList = [];
    }
  }
  let currentMenuCode = null;
  menuList.forEach(item=>{
    if(item.path.indexOf(to.path)>=0){
      currentMenuCode = item.code;
    }
  })
  if(!currentMenuCode){
    menuList.forEach(item=>{
      let path2 = to.meta && to.meta.parent || null;
      if(path2 && item.path.indexOf(path2)>=0){
        currentMenuCode = item.code;
      }
    })
  }
  localStorage.setItem("currentMenuCode",currentMenuCode);
}

router.beforeEach(async (to, from, next) => {
  // 数据埋点 路由切换
  try {
    if(sensors){
      sensors.quick('isReady', function () {
        sensors.getPresetProperties();  // 页面地址，页面标题，前向地址，SDK 类型及版本，屏幕宽高，最近一次的相关属性，如果服务端需要使用这些属性需要客户自己传输,且这些属性不包括需要后端解析的 ip 及 UA 等属性。
      });
    }
  } catch (error) {
    console.log("埋点加载出现异常")
  }
 

  if(!(to.meta && to.meta.noLogin)){
    await getCurrentMenuCode(to);
  }
    
  // 设置title
  document.title = '中软国际云服务-华夏云网'
  const isLogin = utils.getIsLogin()
  if (isLogin !== 'TRUE' || !store.state.main.userInfo.userCode) {
    if (!to.meta.noLogin) {
      await Promise.all([store.dispatch('getInfo'), store.dispatch('queryAccountType'), store.dispatch('queryPartenrStatus')]);
         // await store.$loadNavMenuData() //多租户 头部导航 权限控制
     
    } 
  }
   /**************************处理功能开通逻辑******************************* */
  let hasPermission = store.$routerHasPermission(to)
  if (!hasPermission ) {
      //没有开通当前路由权限
      next({
        path: '/control/notAllow',
        replace: true
      })
      return
    }else{
      next()
    }
})

router.afterEach(() => {

})



// WEBPACK FOOTER //
// ./src/common/permission.js